<p-sidebar [visible]="true"
           [position]="'right'"
           [baseZIndex]="10000"
           [modal]="true"
           (onHide)="onSideBarHide()"
           [style]="{width:'636px'}">

    <ng-template pTemplate="header">
        <div class="flex-row">
            <!-- Avatar -->
            <div *ngIf="!profile.ImageUrl" class="partner-profile-header-avatar-empty">
                {{profile.FirstName | slice:0:1 | uppercase}}{{profile.LastName | slice:0:1 | uppercase}}
            </div>
            <div *ngIf="profile.ImageUrl">
                <img class="partner-profile-header-avatar" src="{{profile.ImageUrl}}" />
            </div>
            <!-- User name -->
            <div style="margin: 6px 0 0 10px">
                <div class="partner-profile-header-avatar-username">
                    {{profile.FirstName}} {{profile.LastName}}
                </div>
                <div class="partner-profile-header-avatar-role">
                    {{userRoleName}}
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <p-tabMenu [model]="menuItems"
                   [activeItem]="activeItem"
                   (activeItemChange)="onActiveItemChange($event)"></p-tabMenu>

        <div style="height: 14px"></div>

        <partner-profile-info-tab *ngIf="activeItem.id===partnerProfileTab.Info"
                                  [parent]="this"></partner-profile-info-tab>

        <partner-profile-security-tab *ngIf="activeItem.id===partnerProfileTab.Security"
                                      [parent]="this"></partner-profile-security-tab>

        <partner-profile-email-tab *ngIf="activeItem.id===partnerProfileTab.Email"
                                   [parent]="this"></partner-profile-email-tab>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex-row" style="padding: 30px;">
            <div class="filler"></div>
            <div>
                <button pButton type="button" label="Update"
                        (click)="onSaveClick()"></button>
            </div>
        </div>
    </ng-template>
</p-sidebar>

<spinner *ngIf="isSpinnerVisible" style="position: fixed; top: 40vh; left: 74vw; z-index: 12000;"></spinner>
